import { siteConfig } from "@/config/site";
import { Eyebrow, Rise, Section } from "./primitives";

const WHY = [
  {
    k: "Founder-led strategy",
    d: `You'll never be handed off to a junior account manager. ${siteConfig.founder.name} runs the technical roadmap and strategy for every Austin engagement personally.`,
  },
  {
    k: "Engineering-first SEO",
    d: "We don't just write audits; we write the fix. Our team understands React, SSR, and rendering pipelines as well as we understand crawl budgets.",
  },
  {
    k: "AI-native thinking",
    d: "Google is changing. We optimize for the ecosystem (ChatGPT, Perplexity, Overviews) alongside the classic search results your competitors are still chasing.",
  },
  {
    k: "Transparent data",
    d: "No black boxes. You get access to the same live GSC and Semrush dashboards we use to track your growth, updated in real-time.",
  },
];

export function HomeWhyUsV2() {
  const city = siteConfig.contact.address.city;

  return (
    <Section labelledBy="why-heading">
      <div className="container-page py-20 md:py-28">
        <div className="grid gap-12 lg:grid-cols-[1fr_1.1fr] lg:gap-16">
          <div>
            <Eyebrow>The difference</Eyebrow>
            <h2
              id="why-heading"
              className="mt-5 text-balance font-display text-3xl leading-[1.06] sm:text-4xl lg:text-5xl"
            >
              Why {city} businesses partner with {siteConfig.name}.
            </h2>
            <p className="mt-6 text-base leading-relaxed text-muted-foreground md:text-lg">
              Most agencies sell "SEO" as a generic commodity. We treat it as an
              engineering discipline that must return a measurable yield on your
              unit economics.
            </p>
          </div>

          <ul className="grid gap-6 sm:grid-cols-2">
            {WHY.map((w, i) => (
              <Rise as="li" key={w.k} delay={(i % 4) as 0 | 1 | 2 | 3}>
                <div className="h-full rounded-2xl border border-border bg-surface-2 p-6 transition-colors duration-300 hover:border-primary/45">
                  <h3 className="font-display text-lg leading-tight">{w.k}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
                    {w.d}
                  </p>
                </div>
              </Rise>
            ))}
          </ul>
        </div>
      </div>
    </Section>
  );
}
